require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-content-writing-website-copy.json") })
        }
      }, "path---services-content-writing-website-copy");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-content-writing-website-copy!./.cache/json/services-content-writing-website-copy.json
// module id = 738
// module chunks = 231608221292675